<div class="main">
  <app-nav-header></app-nav-header>
  <div class="main-content">
    <router-outlet></router-outlet>
    <div class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <div>
            <div class="footer-title">{{ 'navigation.ordering' | translate }}</div>
            <ul>
              <li>
                <a routerLink="/catalogs">{{ 'navigation.catalogs' | translate }}</a>
              </li>
              <li>
                <a routerLink="/orders">{{ 'navigation.orders' | translate }}</a>
              </li>
              <!-- <li><a href="#">FAQs</a></li> -->
            </ul>
          </div>
          <div>
            <!-- <div class="footer-title">Resources</div>
            <ul>
              <li>
                <a href="#" target="_blank" rel="noopener">
                  Website
                  <span
                    ><ui-svg-icon svgIcon="arrow-up-right"></ui-svg-icon
                  ></span>
                </a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener">
                  Documents
                  <span
                    ><ui-svg-icon svgIcon="arrow-up-right"></ui-svg-icon
                  ></span>
                </a>
              </li>
            </ul> -->
          </div>
        </div>
        <hr class="footer-divider" />
        <div class="footer-bottom">
          &copy; {{ year }}. Powered by
          <img src="assets/images/volta-logo-white.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="cart-overview" *ngIf="activeRoute !== '/cart' && cartTotalItems">
      <div class="cart-overview-content">
        <div class="cart-overview-item overview-stats">
          <span class="info">
            {{ 'quotes_and_order.products' | translate }}
            <span class="info-value">{{ cartTotalItems }}</span>
          </span>
          <span class="info">
            {{ 'common.units' | translate }}
            <span class="info-value">{{ cartTotalUnits }}</span>
          </span>
        </div>
        <div class="cart-overview-item overview-total">
          <span class="info">
            {{ 'product.total' | translate }}
            <span class="info-value" *ngFor="let cart of cartsTotalPricePerCurrency">
              {{ cart.total | amountCurrency: cart.currency?.symbol: cart.currency?.position }}
            </span>
          </span>
          <div class="view-cart" (click)="goToCart()">
            <ui-svg-icon svgIcon="cart"></ui-svg-icon>
            {{ 'navigation.go_to_cart' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
